import img from './assets/NoResultsFound.svg'

import { s } from './styles'

type Props = {
  title?: string
  subTitle?: string
  dataTestid?: string
}

export const NoResultsFound = (props: Props) => {
  const { title, subTitle, dataTestid } = props

  return (
    <s.Box data-testid={dataTestid}>
      <s.Img dangerouslySetInnerHTML={{ __html: img }} />
      <s.Title>{title || 'No Results Found'}</s.Title>
      <s.SubTitle>{subTitle || 'Try adjusting your search terms or filters'}</s.SubTitle>
    </s.Box>
  )
}
